import React from "react";
import PropTypes from "prop-types";
import classnames from "classnames";

const localeSeperator = ",";//((0.5).toLocaleString().match(/\D/) || ["."])[0];
const localeGroupSeperator = "";//((1000000000).toLocaleString().match(/\D/) || [""])[0];
const localeGroupSeperatorRegexp = new RegExp(localeGroupSeperator, "g");

import {generateGuid} from "../../util/guid";
import Tooltip from "../common/Tooltip";
import * as types from "../../constants/ComponentConstants";
import ValidationMessage from "../common/ValidationMessage";
import Revert from "../common/Revert";
import './NumberInput.css';

function numberWithDuizendtallen(x) {
	x = x.replace(/[.]/g, "");
	return x.replace(/\B(?=(\d{3})+(?!\d))/g, ".");
}


const NumberInput = (props) => {
	const hasValue = props.value === 0 || !!props.value;
	const hasValidationMessage = !!props.validationMessage;
	const validationMessageType = props.validationMessageType;
	const fullWidthInput = !!props.fullWidthInput;
	const tooltiptype = props.tooltipType || types.TOOLTIP_INFO;
	const value = props.value === 0 || props.value ? props.value : "";
	const sizeClassName = props.size ? "o-col-" + props.size : "o-col-12";
	const label = props.label + (props.optional ? " (Optioneel)" : "");
	const info = props.tooltip ? <Tooltip isInput text={props.tooltip} tooltipType={tooltiptype} /> : null;
	const validation = props.validationMessage && !props.hideValidation ? <ValidationMessage message={props.validationMessage} type={validationMessageType} /> : null;
	const valuta = props.isValuta ? <span className="c-input__prefix">€</span> : null;
	const prefixComponent = props.prefix ? <span className="c-input__prefix">{props.prefix}</span> : null;
	const id = generateGuid();
	const applyNoPaddinStyle = props.applyNoPaddinStyle ? props.applyNoPaddinStyle : false;

	const revertable = (props.disabled !== true && props.disabled !== 'true') && props.originalValue !== null ? (props.originalValue || "") !== (props.value || "") : false;

	const inputClassName = props.isSmall ? classnames({
		"c-input small": true,
		"c-input small--fullwidth": fullWidthInput
	}) : classnames({
		"c-input__field": true,
		"c-input__field--fullwidth": fullWidthInput
	});
	const labelClassName = classnames({
		"c-input__label": true,
		"has-value": hasValue
	});

	const containerClassName = classnames({
		"c-input": !props.isSmall,
		"c-input small": props.isSmall,
		"has-value": hasValue,
		"error": hasValidationMessage,
		"warning": hasValidationMessage && validationMessageType === types.ValidationMessageTypes.WARNING,
		"disabled": props.disabled,
		"currency": props.isValuta
	});

	//TODO ADD IGNORE TEXT INSTEAD OF REMOVING EVERYTHING
	function onChange(e) {
		let targetValue = e.target.value.toString();

		const regexDecimalPoint = props.oneDecimal ? /\.(?=\d{0,1}$)/ : /\.(?=\d{0,2}$)/;
		const hasDecimalThatNeedsConversion = /\.$/;
		const regexDecimalComma = props.oneDecimal ? /,(?=\d{0,1}$)/ : /,(?=\d{0,2}$)/;
		//if (!props.noDecimals && regexDecimalPoint.test(targetValue)) { targetValue = targetValue.toString().replace(regexDecimalPoint, ","); }
		if (hasDecimalThatNeedsConversion.test(targetValue)) { targetValue = targetValue.toString().replace(hasDecimalThatNeedsConversion, ","); }
		let input = (targetValue === localeSeperator || targetValue === '.') ? '0' + localeSeperator : targetValue;
		input = input.toString().replace(/\./g, "");
		const value = input === '' ? null : props.dontParse ? targetValue : String(input.replace(regexDecimalComma, '.'));
		const inputValue = props.dontParse ? value : parseToDisplayValue(value);
		if (isNaN(value))
			return;
		if (props.noDecimals) {
			if (value)
				if (value.indexOf('.') >= 0 || value.indexOf(',') >= 0)
					return;
		}

		const fakedEvent = { target: { value: value, name: e.target.name } };

		if (props.onChange)
			props.onChange(fakedEvent);

	}

	function parseToDisplayValue(targetValue) {
		if (isNaN(targetValue) || targetValue === undefined || targetValue === "")
			return "";

		const regexDecimalPoint = props.oneDecimal ? /\.(?=\d{0,1}$)/ : /\.(?=\d{0,2}$)/;
		const regexDecimalComma = props.oneDecimal ? /,(?=\d{0,1}$)/ : /,(?=\d{0,2}$)/;

		if (regexDecimalPoint.test(targetValue)) { targetValue = targetValue.toString().replace(regexDecimalPoint, ","); }
		let input = (targetValue === localeSeperator || targetValue === '.') ? '0' + localeSeperator : targetValue;

		if (input === null)
			return null;

		input = input.toString().replace(/\./g, "");

		const str = numberWithDuizendtallen(input);

		return str;
	}

	const style = { margin: '0px', padding: '0px' };
	const inputValue = props.dontParse ? value : parseToDisplayValue(value);

	return (
		<div className={sizeClassName} >
			<div className={containerClassName} style={applyNoPaddinStyle ? style : null}>
				{valuta}
				{prefixComponent}
				<input
					id={id}
					value={inputValue}
					disabled={props.disabled}
					onChange={onChange}
					className={inputClassName}
					name={props.name} />
				<label
					className={labelClassName}
					htmlFor={id}>
					{label}
				</label>
				{info}
				{!revertable || <Revert
					onChange={props.onChange}
					name={props.name}
					originalValue={props.originalValue} />}
			</div>
			{validation}
		</div>
	);
};

NumberInput.propTypes = {
	name: PropTypes.string.isRequired,
	label: PropTypes.string.isRequired,
	value: PropTypes.oneOfType([
		PropTypes.number,
		PropTypes.string
	]),
	originalValue: PropTypes.oneOfType([
		PropTypes.number,
		PropTypes.string
	]),
	onChange: PropTypes.func,
	tooltip: PropTypes.string,
	tooltipType: PropTypes.string,
	validationMessage: PropTypes.string,
	validationMessageType: PropTypes.string,
	disabled: PropTypes.bool,
	readOnly: PropTypes.bool,
	size: PropTypes.number,
	optional: PropTypes.bool,
	isValuta: PropTypes.bool,
	hideValidation: PropTypes.bool,
	fullWidthInput: PropTypes.bool,
	oneDecimal: PropTypes.bool,
	noDecimals: PropTypes.bool,
	isSmall: PropTypes.bool,
	applyNoPaddinStyle: PropTypes.bool,
	prefix: PropTypes.string,
	dontParse: PropTypes.bool
};

export default NumberInput;
